import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from './Button';
import { parsePrice } from '../../utils/index';
import DaysAmount from './daysAmount';
import {
  faCheck,
  faPlusCircle,
  faTrash,
} from '@fortawesome/pro-regular-svg-icons';
import { useWindowSize } from 'react-use';

const ExtrasOrder = ({
  amount,
  decrease,
  description,
  disableIncrease,
  image,
  increase,
  name,
  onClick,
  price,
  removeCb,
  selected,
}) => {
  const { width } = useWindowSize();

  return (
    <div className={`extras-order ${selected ? 'extras-order--selected' : ''}`}>
      {selected && (
        <div className="extras-order__check">
          <FontAwesomeIcon className="font-size-15" icon={faCheck} />
        </div>
      )}
      <div className="display-flex">
        <img
          alt={name}
          height={160}
          src={image || 'https://static.dietly.pl/form/placeholder.jpg'}
          width={160}
        />
        <div className="extras-order__description">
          <h6 className="label-m spacer-bottom-8">{name}</h6>
          {description && <p className="body-s">{description}</p>}
        </div>
      </div>
      <div className="display-flex flex-wrap justify-content-space-between align-items-center">
        <div className="display-flex spacer-top-8">
          {selected ? (
            <>
              <div className="extras-order__amount">
                <DaysAmount
                  days={amount}
                  decrease={decrease}
                  disableIncrease={disableIncrease}
                  increase={increase}
                  withoutBorders
                />
              </div>
              <div className="extras-order__button">
                <Button
                  colorBlank
                  icon={
                    width < 768 && (
                      <FontAwesomeIcon
                        className="color-gray-400"
                        icon={faTrash}
                      />
                    )
                  }
                  label={width > 768 && 'Usuń'}
                  onClick={removeCb}
                />
              </div>
            </>
          ) : (
            <Button
              colorBlank
              containerClass="color-primary"
              icon={<FontAwesomeIcon icon={faPlusCircle} />}
              label="Dodaj"
              onClick={onClick}
            />
          )}
        </div>
        <div className="label-m color-primary spacer-top-8">
          {parsePrice(price, 2)} zł / szt.
        </div>
      </div>
    </div>
  );
};

ExtrasOrder.propTypes = {
  amount: PropTypes.number,
  decrease: PropTypes.func,
  disableIncrease: PropTypes.bool,
  image: PropTypes.string,
  increase: PropTypes.func,
  name: PropTypes.string,
  onClick: PropTypes.func,
  price: PropTypes.number,
  selected: PropTypes.bool,
};

export default ExtrasOrder;
